module.exports = __webpack_public_path__ + "img/logo.d0cdff29.png";